import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TaskWorkspaceStore } from '../../../../../core/h3ml/state/task-workspace-store';
import { ToolsHelperService } from '../../../../../cross-team-shared/misc-services/tools-helper.service';
import { isVideoOutput } from '../../../../../cross-team-shared/misc-utils/output-utils';
import {
  DEFAULT_BRIGHTNESS,
  DEFAULT_CONTRAST,
} from '../../../../../cross-team-shared/state/layer-settings-state-2d';
import { defaultShapeOpacity } from '../../../../../cross-team-shared/state/layer-settings-state-3d';
import { settingsStoreToken } from '../../../../../cross-team-shared/state/setting-state';
import { EventTrackingService } from '../../../../../shared/event-tracking/event-tracking.service';

@Component({
  selector: 'h3-view-settings2d',
  templateUrl: './view-settings2d.component.html',
  styleUrl: './view-settings2d.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewSettings2dComponent {
  private readonly settingsStore =
    inject(settingsStoreToken)('layerSettings2d');
  private readonly eventTrackingService = inject(EventTrackingService);
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);
  private readonly toolsHelperService = inject(ToolsHelperService);

  defaultLayerOpacity = defaultShapeOpacity;
  defaultBrightness = DEFAULT_BRIGHTNESS;
  defaultContrast = DEFAULT_CONTRAST;
  layerOpacityStore = this.settingsStore('opacity');
  brightnessStore = this.settingsStore('brightness');
  contrastStore = this.settingsStore('contrast');
  showShapeDimensionsStore = this.settingsStore('showShapeDimensions');
  hideOccludedShapesStore = this.settingsStore('hideOccludedShapes');
  alwaysShowSubpointsStore = this.settingsStore('alwaysShowSubpoints');
  swapLayerOnSelectStore = this.settingsStore('swapLayerOnSelect');
  zoomPanelEnabledStore = this.settingsStore('zoomPanelEnabled');
  hasRectangleTool = this.getHasRectangleTool();
  hasNonOrthographicOutput = this.getHasNonOrthographicOutput();

  trackShowDimensionsChange() {
    this.eventTrackingService.track({
      id: 'toggle_show_rectangle_dimensions',
      bucket: 'navigation',
      sub_bucket: 'frame',
      new_value: this.showShapeDimensionsStore.state(),
    });
  }

  trackHideOccludedShapesChange() {
    this.eventTrackingService.track({
      id: 'toggle_hide_occluded_shapes',
      bucket: 'navigation',
      sub_bucket: 'frame',
      new_value: this.hideOccludedShapesStore.state(),
    });
  }

  private getHasRectangleTool() {
    const { project } = this.taskWorkspaceStore.state();

    return project.outputs
      .filter(isVideoOutput)
      .some((output) =>
        this.toolsHelperService
          .getAllowedTools(output.name)
          .some((tool) => tool === 'Rectangle' || tool === 'SliderRectangle'),
      );
  }

  private getHasNonOrthographicOutput() {
    const { project } = this.taskWorkspaceStore.state();

    return project.outputs.some(
      (output) =>
        isVideoOutput(output) && !output.meta.is_orthographic_projection,
    );
  }
}
